import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Result, Button, Spin, Row, Col } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import axios from "axios";

const AccountActivation = () => {
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const [activationStatus, setActivationStatus] = useState("processing");
  const [errorMessage, setErrorMessage] = useState("");

  const getActivationToken = () => {
    return searchParams.get("token");
  };

  const activateAccount = async (token) => {
    try {
      const response = await axios.post("/api/accounts/activate/", {
        token: token,
      });

      if (response.status === 200) {
        setActivationStatus("success");
        setTimeout(() => navigate("/login", { replace: true }), 5000);
      }
    } catch (error) {
      setActivationStatus("error");
      if (error.response) {
        setErrorMessage(
          error.response.data.message || "Failed to activate account"
        );
      } else {
        setErrorMessage("Network error, please try again");
      }
    }
  };

  useEffect(() => {
    const token = getActivationToken();
    if (!token) {
      setActivationStatus("error");
      setErrorMessage("Invalid activation token");
      return;
    }
    activateAccount(token);
  }, []);

  return (
    <Row justify="center" style={{ marginTop: 100 }}>
      <Col xs={24} sm={12} md={8} lg={6}>
        <div style={{ padding: 24, background: "#fff", borderRadius: 4 }}>
          {activationStatus === "processing" ? (
            <Spin tip="Account activation ..." size="large">
              <div
                style={{
                  padding: "50px",
                  background: "rgba(0, 0, 0, 0.05)",
                }}
              />
            </Spin>
          ) : (
            <Result
              icon={
                activationStatus === "success" ? (
                  <CheckCircleOutlined
                    style={{
                      color: "#52c41a",
                      fontSize: 72,
                    }}
                  />
                ) : (
                  <CloseCircleOutlined
                    style={{
                      color: "#ff4d4f",
                      fontSize: 72,
                    }}
                  />
                )
              }
              title={
                activationStatus === "success"
                  ? "Account activated successfully"
                  : `Failed to activate account: ${errorMessage}`
              }
              subTitle={
                activationStatus === "success"
                  ? "You can now login to your account"
                  : "Please contact customer support for assistance"
              }
              extra={[
                activationStatus === "success" ? (
                  <Button
                    type="primary"
                    key="login"
                    onClick={() =>
                      navigate("/login", {
                        replace: true,
                      })
                    }
                  >
                    Login
                  </Button>
                ) : (
                  <>
                    <Button
                      type="primary"
                      key="retry"
                      onClick={() => window.location.reload()}
                    >
                      Retry
                    </Button>
                    <Button
                      key="support"
                      onClick={() =>
                        navigate("/contact", {
                          replace: true,
                        })
                      }
                      style={{ marginLeft: 8 }}
                    >
                      Contact Support
                    </Button>
                  </>
                ),
              ]}
            />
          )}
        </div>
      </Col>
    </Row>
  );
};

export default AccountActivation;
